import React from 'react';
import classNames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';

interface IAddButtonProps {
  className?: string;
  text?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const AddButton: React.FC<IAddButtonProps> = (props) => {
  const { className, text, onClick, disabled = false } = props;

  return (
    <div
      className={classNames('dbl-add-button', className, { 'dbl-add-button--disabled': disabled })}
      onClick={() => {
        if (!disabled) {
          onClick?.();
        }
      }}
    >
      <SvgIcon type="add-bg-icon" className="dbl-add-button-icon" />
      <div className="dbl-add-button-text">{text}</div>
    </div>
  );
};

export default AddButton;